import { render, staticRenderFns } from "./TreeviewCampaigns.vue?vue&type=template&id=728f2a42&scoped=true&"
import script from "./TreeviewCampaigns.vue?vue&type=script&lang=js&"
export * from "./TreeviewCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./TreeviewCampaigns.vue?vue&type=style&index=0&id=728f2a42&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728f2a42",
  null
  
)

export default component.exports